<div class="block card-container-grey padding-md border-radius-sm" [class.card-container-active]="active">
  <img loading="lazy" [src]="value.img || './../../../assets/images/icons/icons8-morning-100.png'" alt="">
  <div>
    <p class="text-regular-14">{{ value.title || '' }}</p>
    <p class="text-info">{{ value.dateText || '' }}</p>
  </div>
  <div class="card-container-icon-active" *ngIf="active">
    <img loading="lazy" src="./../../../assets/images/icons/icons8-checkmark-100.png" alt="">
  </div>
</div>
